import { Link } from "react-router-dom";
import Layout, { Section } from "@/components/layout/Layout";
import useNoIndex from "@/lib/useNoIndex";
import useOgMeta from "@/lib/useOgMeta";
import { ArrowLeft } from "lucide-react";

// Shared "not found" body for invalid dynamic-route slugs (an insight,
// case study, industry, or role that doesn't exist). The SPA server still
// answers these with HTTP 200 (see docs/decisions/006), so this at least
// keeps the invalid URL out of the index and gives a real way back.
//
// A route like InsightDetail re-renders in place when its :slug param
// changes from a real article to an invalid one — without this, a stale
// og:title/description/image/twitter:image (and Layout's own meta
// description) from the previously-viewed real article would keep
// describing this invalid-slug page. Forcing them absent here (and
// restoring whatever was there before on unmount) prevents that; passing
// `description` ensures Layout's own meta-description effect has something
// current to set rather than leaving a stale one in place.
export default function DetailNotFound({ title, description = "The page you're looking for doesn't exist.", heading, backTo, backLabel }) {
    useNoIndex();
    useOgMeta({ title: null, description: null, image: null, twitterImage: null });
    return (
        <Layout title={title} description={description} notFound>
            <Section className="pt-40 pb-32">
                <p className="label">404</p>
                <h1 className="font-serif font-light text-5xl sm:text-6xl mt-6 tracking-tight">{heading}</h1>
                <Link to={backTo} className="mt-8 inline-flex items-center gap-2 text-sm border-b border-foreground/40 pb-1">
                    <ArrowLeft className="h-4 w-4" /> {backLabel}
                </Link>
            </Section>
        </Layout>
    );
}
